import Dashboard from './home/Dashboard.vue';

import BuildingManagement from './home/BuildingManagement.vue';
import {routers as BuildingManagementChildrenRouters} from './home/BuildingManagement.js';

import BuildingUserManagement from './home/BuildingUserManagement.vue';
import {routers as BuildingUserManagementChildrenRouters} from './home/BuildingUserManagement.js';

import HardwareManagement from './home/HardwareManagement.vue';
import {routers as HardwareManagementChildrenRouters} from './home/HardwareManagement.js';

import SiteManagement from './home/SiteManagement.vue';
import {routers as SiteManagementChildrenRouters} from './home/SiteManagement.js';

import WarrantyManagement from './home/WarrantyManagement.vue';
import {routers as WarrantyManagementChildrenRouters} from './home/WarrantyManagement.js';

import EmailManagement from './home/EmailManagement.vue';
import {routers as EmailManagementChildrenRouters} from './home/EmailManagement.js';

import PageError from './PageError.vue';

import UserProfile from "@/pages/home/UserProfile.vue";
import {routers as UserProfileChildrenRouters} from './home/UserProfile.js';

let routes = [
  {
    name: 'dashboard',
    path: 'dashboard',
    component: Dashboard,
  },
  {
    name: 'building-management',
    path: 'building-management/list-buildings',
    component: BuildingManagement,
    children: BuildingManagementChildrenRouters,
  },
  {
    name: 'building-user-management',
    path: 'building-user-management',
    component: BuildingUserManagement,
    children: BuildingUserManagementChildrenRouters,
  },
  {
    name: 'warranty-management',
    path: 'warranty-management',
    component: WarrantyManagement,
    children: WarrantyManagementChildrenRouters,
    meta: {
      permissions: ['DEVELOPER_MODE']
    }
  },
  {
    name: 'hardware-management',
    path: 'legacy-hardware-management',
    component: HardwareManagement,
    children: HardwareManagementChildrenRouters,
    meta: {
      permissions: ['DEVELOPER_MODE']
    },
    redirect: {
      name: 'devices'
    }
  },
  {
    name: 'site-management',
    path: 'site-management',
    component: SiteManagement,
    children: SiteManagementChildrenRouters,
    meta: {
      permissions: ['DEVELOPER_MODE']
    },
    redirect: {
      name: 'show-building-navbar'
    }
  },
  {
    name: 'email-management',
    path: 'email-management',
    component: EmailManagement,
    children: EmailManagementChildrenRouters,
    meta: {
      permissions: ['DEVELOPER_MODE']
    }
  },
  {
    name: 'user-profile',
    path: 'user-profile',
    component: UserProfile,
    children: UserProfileChildrenRouters,
    redirect: {
      name: 'user-notification'
    }
  },
  {
    name: 'ERROR',
    path: '/error',
    component: PageError,
    props: true
  },
];
export { routes };